import { ServerConnection, type useServer } from "@/context/server"
import type { MachineRouteInput } from "./machine-route-manager"
import { reportRouteEvent } from "./route-telemetry"
import type { MachineRouteReport } from "@/transport/fleet"

function describeRoute(machine: MachineRouteInput, url?: string) {
  if (!url) return { kind: "none" as const }
  if (url.replace(/\/+$/, "") === machine.local_url?.replace(/\/+$/, "")) return { kind: "direct-local" as const }
  return { kind: "direct-public" as const, provider: machine.public_routes?.find(route => route.url.replace(/\/+$/, "") === url.replace(/\/+$/, ""))?.provider }
}

export function installMachineTransport(
  server: Pick<ReturnType<typeof useServer>, "list" | "add">,
  machine: MachineRouteInput,
  http: ServerConnection.HttpBase,
  trigger: NonNullable<MachineRouteReport["trigger"]>,
) {
  const connection: ServerConnection.Http = { type: "http", displayName: machine.name, http }
  const previous = server.list.find(entry => ServerConnection.key(entry) === ServerConnection.key(connection))
  const previousURL = previous?.http.url
  // Replace the same logical entry. An inactive machine's recovery must never steal focus.
  const installed = server.add(connection, { activate: false, persist: false })
  if (installed && previousURL !== installed.http.url) {
    const before = describeRoute(machine, previousURL)
    const after = describeRoute(machine, installed.http.url)
    reportRouteEvent({ machine: machine.name, kind: "transition", trigger,
      previous: before.kind, previous_provider: before.provider,
      selected: after.kind, selected_provider: after.provider, attempts: [],
    })
  }
  return installed
}
